// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2nICC","label":"CategoryService_label__kIZcP","location":"CategoryService_location__2VrGz"};